<template>
  <BaseSelect
    :options="options"
    :model-value="modelValue"
    :placeholder="placeholder"
    :searchable="true"
    :search-placeholder="searchPlaceholder"
    :clearable="clearable"
    :invalid="invalid"
    :disabled="disabled"
    :no-results-text="noResultsText"
    @update:model-value="handleUpdate"
    @change="handleChange"
  />
</template>

<script>
import {
  getTimezoneLabel,
  getTimezoneOptions,
} from "@/utils/timezoneUtils";

export default {
  name: "TimezoneSelect",

  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Выберите часовой пояс",
    },
    searchPlaceholder: {
      type: String,
      default: "Поиск по городу или тайм-зоне",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noResultsText: {
      type: String,
      default: "Часовой пояс не найден",
    },
  },

  emits: ["update:modelValue", "change"],

  data() {
    return {
      options: getTimezoneOptions(),
    };
  },

  watch: {
    modelValue: {
      handler(value) {
        this.ensureTimeZoneOption(value);
      },
      immediate: true,
    },
  },

  methods: {
    handleUpdate(value) {
      this.ensureTimeZoneOption(value);
      this.$emit("update:modelValue", value);
    },

    handleChange(option) {
      this.$emit("change", option ? option.value : null);
    },

    ensureTimeZoneOption(timeZone) {
      if (!timeZone) return;

      const exists = this.options.some(
        (option) => option.value === timeZone
      );

      if (!exists) {
        this.options.push({
          value: timeZone,
          label: getTimezoneLabel(timeZone),
        });
      }
    },
  },
};
</script>
